import { Select } from "antd";
import { SelectComPesquisa } from "../../../SelectComPesquisa";
import { TypeCentroCusto } from "../../../../Models/Financeiro/CentroCusto";
import { useCentroCustoListar, useCentroCustoListarValidos } from "../../../../Services/Financeiro/CentroCustoService";

type CentroDeCustoCodigo = NonNullable<TypeCentroCusto["codigo"]>;

interface ICentroCustoSelectProps extends Omit<React.ComponentProps<typeof Select>, "onChange" | "value" | "showSearch" | "optionFilterProp" | "filterOption"> {
    filtros?:TypeCentroCusto;
    fechado?:boolean;
    codCentroCustoInvalidarFiltro?:Array<number>,
    onChange?:((centroCusto:TypeCentroCusto|null) => void)|((codigoCentrosCustos?:number[]|null, centosCustos?:TypeCentroCusto[]|null) => void);
    value?:TypeCentroCusto|null;
}
export default function CentroCustoSelect({
    filtros,
    fechado,
    codCentroCustoInvalidarFiltro,
    loading,
    placeholder,
    allowClear,
    onChange,
    value,
    ...rest
}:ICentroCustoSelectProps) {
    placeholder = placeholder ?? "Selecione";
    allowClear = allowClear ?? true;
    loading = loading ?? false;
    filtros = filtros ?? {};
    fechado = fechado ?? undefined;
    filtros.ativo = filtros.ativo ?? true;
    codCentroCustoInvalidarFiltro = codCentroCustoInvalidarFiltro ?? [];

    const {
        data,
        isLoading
    } = useCentroCustoListarValidos({
        centroCusto : filtros,
        fechado : fechado,
        codCentroCustoInvalidarFiltro : codCentroCustoInvalidarFiltro
    });

    return <SelectComPesquisa
        {...rest}
        placeholder={placeholder}
        allowClear={allowClear}
        loading={isLoading || loading}
        onChange={(codigo) => {
            if (rest.mode === "multiple")
                onChange?.(codigo, codigo?.map(m => data?.find(f => f.codigo == m)) ?? null);
            else
                onChange?.(data?.find(f => f.codigo == (codigo ?? null)) ?? null);
        }}
        value={value?.codigo}
        options={data?.map(m => {
            return {
                value : m.codigo,
                label : m.descricao
            }
        })}
    />
}

export interface ICentroCustoSelectItemProps extends Omit<ICentroCustoSelectProps, "value"|"onChange"|"mode"> {
    onChange?:(value?:CentroDeCustoCodigo, record?:TypeCentroCusto) => void;
    value?:CentroDeCustoCodigo;
    fechado?:boolean;
    codCentroCustoInvalidarFiltro?:Array<number>
}
export function CentroCustoSelectItem({
    onChange,
    value,
    fechado,
    codCentroCustoInvalidarFiltro,
    ...rest
}:ICentroCustoSelectItemProps) {
    return <CentroCustoSelect 
        {...rest}
        mode={undefined}
        fechado={fechado}
        codCentroCustoInvalidarFiltro={codCentroCustoInvalidarFiltro}
        value={{
            codigo : value
        }}
        onChange={(value?:TypeCentroCusto|null) => {
            onChange?.(value?.codigo ?? undefined, value ?? undefined);
        }}
    />
};